import styled from 'styled-components';

const Wrapper = styled.section`
  display: flex;
  justify-content: center;

  @media (max-width: 700px) {
    flex-direction: column;
    align-items: center;
  }

  .checkout-wrapper {
    display: flex;
    justify-content: center;
    padding: 40px 20px;
  }

  .checkout-card {
    width: 100%;
    max-width: 850px;
    background: #ffffff;
    padding: 30px;
    border-radius: 18px;
    box-shadow: 0 4px 25px rgba(0, 0, 0, 0.08);
    border-top: 6px solid #1e3a8a; /* Blue */
  }

  .checkout-title {
    text-align: center;
    font-size: 22px;
    color: #1e3a8a; /* Blue */
    font-weight: 700;
    margin-bottom: 20px;
  }

  .divider {
    text-align: center;
    margin: 15px 0;
    color: #555;
  }

  .divider span {
    font-weight: 600;
    color: #1e3a8a;
  }

  .checkout-form {
    display: flex;
    flex-direction: column;
    min-width: 250px;
    gap: 15px;
  }

  .form-input {
    width: 100%;
    padding: 14px;
    border-radius: 10px;
    border: 1.5px solid #d1d5db;
    background: #f9fafb;
    font-size: 15px;
    transition: all 0.2s ease;
  }

  .form-input:focus {
    border-color: #1e3a8a; /* Blue */
    background: #ffffff;
    box-shadow: 0 0 4px rgba(30, 58, 138, 0.3);
  }

  .save-address {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 14px;
    color: #333;
  }

  .confirm-btn {
    width: 100%;
    padding: 14px;
    background: #d3a143; /* Yellow */
    color: white;
    font-size: 16px;
    border: none;
    border-radius: 10px;
    font-weight: 600;
    cursor: pointer;
    transition: 0.2s;
  }

  .confirm-btn:hover {
    background: #b8862b;
  }

  .confirm-btn:disabled {
    background: #e5c784;
    cursor: not-allowed;
  }

  @media (max-width: 700px) {
    .PaymentDiv {
      margin-left: 0px;
      margin-bottom: 30px;
    }
  }
  @media (min-width: 768px){
  .checkout-form{
  min-width:350px;
  }
  }
`;

const WrapperDiv = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  .empty {
    text-align: center;
  }
`;

export { Wrapper, WrapperDiv };
